// Expose the Nette Ajax and Forms
import './nette.ajax'
import Nette from './nette.forms'

window.Nette = Nette
Nette.initOnLoad()
